export const environment = {
  production: false,
  appInsightsInstrumentationKey: "91a893a0-d598-4d0c-8730-45d2f7505026",
  apiUrl: "https://portal-gw-dev.stealthmonitoring.net/",
  dmApiUrl: "https://se-dm-dev.azurewebsites.net/",
  cmsApiUrl: "https://cms-gw-dev.stealthmonitoring.net/",
  cmsAppUrl: "https://hub-dev.stealthmonitoring.net/",
  gtmContainerId: "GTM-MQJQPPC",
  gtmAuthKey: "XasmZ6NRp3an5JAIstlRRw",
  gtmEnvironment: "env-34",
  tokenKey: "Abp.AuthToken",
  hubTokenKey: "Abp.HubAuthToken",
  tenantIdKey: "Abp.TenantId",
  userIdKey: "sc-userid",
  hubUserIdKey: "sc-hubUserid",
  linkedUserKey: "sc-linkedUserList",
  isSsoOnlyUser: "central-ssoLoginUser",
  appVersion: "3.63.0-339896-Create-Site-Details-Wireframe-for-Commons.1.134869",
  awsRegion: "us-east-2",
  awsBucket: "zeus-staging",
  envName: "dev",
  azureClientId: "1d39e2e2-57de-43fc-b371-deb84d59936a",
  azureAuthority: "https://login.microsoftonline.com/organizations",
  azureRedirectUrl: "https://central-dev.ecam.com",
  stsUrl: "https://stealth-sts-dev.stealthmonitoring.net/Auth/ExchangeExternal/",
  rtspUrlDecryptKey: "StE@lth01!!",
  googleMapsApiKey: 'AIzaSyCDve2V_y1mEZBBC7HiVH20LQbfA4sJYZo',
  okta: {
    sewell: {
      issuer: "https://sewell.okta.com",
      audience: "0oa1hoepctnVTYt8i0x8",
      domains: "sewell.com"
    },
    ecam: {
      issuer: "https://garda.okta.com/oauth2/default",
      audience: "0oa25tderc6AbOcXb0h8",
      domains: "ecam.com"
    }
  }
};

